module.exports = __webpack_public_path__ + "e4edaad9e4f42e4e28a685b7e2a6e750.svg";